import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const RESERVATION_URL = "https://www.paintball-aventures.com/";
export const PHONE = "06 68 22 01 60";
export const PHONE_TEL = "+33668220160";
export const EMAIL = "tumoinethomas@hotmail.fr";
export const FACEBOOK_URL = "https://www.facebook.com/PaintballAventures35";
export const TIKTOK_URL = "https://www.tiktok.com/@paintball.aventur";
export const INSTAGRAM_URL = "https://www.instagram.com/tumoinethomas/?g=5";
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_terrain-paintball/artifacts/zepae57j_Logo%20Paintball%20Aventures.png";
export const PDF_ADULTE =
  "https://customer-assets.emergentagent.com/job_terrain-paintball/artifacts/eni3b84h_attestation_adulte.pdf";
export const PDF_ENFANT =
  "https://customer-assets.emergentagent.com/job_terrain-paintball/artifacts/coqj17lu_attestation_enfant.pdf";
export const HERO_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_terrain-paintball/artifacts/r67a7vzp_Paintball%20Aventures%2035_.mp4";
export const FOOD_IMAGE_URL =
  "https://customer-assets.emergentagent.com/job_terrain-paintball/artifacts/8fnvo9c0_Galette%20saucisse.jfif";
export const GOOGLE_REVIEW_FOUGERES =
  "https://www.google.com/search?q=Paintball+aventures+Foug%C3%A8res+Avis";
export const GOOGLE_REVIEW_LOUVIGNE =
  "https://www.google.com/search?q=Paintball+Aventures+35+Avis";
